/**
 * Shared model transfer (download/cache) status/phase constants for messaging-neutral state.
 * Keep these machine-readable; UI maps them to localized strings.
 */
export const MODEL_TRANSFER_STATUS = {
  QUEUED: 'queued',
  DOWNLOADING: 'downloading',
  LOADING: 'loading',
  COMPLETED: 'completed',
  CANCELED: 'canceled',
  ERROR: 'error',
} as const;
export type ModelTransferStatus = typeof MODEL_TRANSFER_STATUS[keyof typeof MODEL_TRANSFER_STATUS];

export const MODEL_TRANSFER_PHASE = {
  PREPARING: 'preparing',
  CHECKING: 'checking',
  DOWNLOADING: 'downloading',
  WRITING: 'writing',
  CACHED: 'cached',
  COMPLETE: 'complete',
  WORKING: 'working',
} as const;
export type ModelTransferPhase = typeof MODEL_TRANSFER_PHASE[keyof typeof MODEL_TRANSFER_PHASE];

export const MODEL_TRANSFER_ERROR = {
  ABORTED: 'aborted',
  NETWORK: 'network',
  HTTP: 'http',
  STORAGE: 'storage',
  UNKNOWN: 'unknown',
} as const;
export type ModelTransferError = typeof MODEL_TRANSFER_ERROR[keyof typeof MODEL_TRANSFER_ERROR];


